export enum LoadState {
    UNSET = 0b0001,
    LOADING = 0b0010,
    LOADED = 0b0100,
    ERROR = 0b1000,
}
